module.exports = __webpack_public_path__ + "icons.e6cf7c6ec7c2d6f670ae9d762604cb0b.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.woff2
// module id = 34
// module chunks = 0